import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { CircularProgress } from "@mui/material";

const LoaderWrapper = styled.div`
  margin-top: 25%;
  text-align: center;
`;

const CustomLoader = () => {
  return (
    <LoaderWrapper>
      <CircularProgress sx={{ color: "#ED1E24" }} size={50} />
    </LoaderWrapper>
  );
};

export default CustomLoader;
